'use client';

import { Icon } from '@chakra-ui/react';
import {
    LuBookOpenText,
    LuCircleHelp,
    LuFileText,
    LuLifeBuoy,
} from 'react-icons/lu';
import { IconMenu, MyAccountMenu } from './my-account-menu';

// Docs & support links as one ?-menu — the sidebar footer holds compact
// icon controls only, so the historical external-link rows fold in here.
// The links are IonQ-universal, so the menu is shared as-is; the trigger
// keeps the question mark while Support Requests gets the lifebuoy, so the
// two don't read as twins.
export function HelpMenu({
    positioning,
}: {
    /** Popover placement override — the mini rail opens menus to the
     * right of the rail instead of above the footer. */
    positioning?: React.ComponentProps<typeof IconMenu>['positioning'];
}) {
    return (
        <IconMenu
            aria-label='Help and support'
            icon={<Icon as={LuCircleHelp} boxSize={4} />}
            positioning={{ placement: 'top-start', ...positioning }}
        >
            {(dismiss) => (
                <>
                    <IconMenu.SectionTitle>Documentation</IconMenu.SectionTitle>
                    <MyAccountMenu.ItemExternalLink
                        href='https://docs.ionq.com'
                        label='Product docs'
                        icon={LuBookOpenText}
                        onClick={dismiss}
                    />
                    <MyAccountMenu.ItemExternalLink
                        href='https://docs.ionq.com/api-reference'
                        label='API Reference'
                        icon={LuFileText}
                        onClick={dismiss}
                    />
                    <IconMenu.SectionTitle>Support</IconMenu.SectionTitle>
                    <MyAccountMenu.ItemExternalLink
                        href='https://support.ionq.com'
                        label='Support Requests'
                        icon={LuLifeBuoy}
                        onClick={dismiss}
                    />
                </>
            )}
        </IconMenu>
    );
}
